import { render, staticRenderFns } from "./plainLabel.vue?vue&type=template&id=322e58ee&"
import script from "./plainLabel.vue?vue&type=script&lang=js&"
export * from "./plainLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports